import React from 'react'
import Link from 'gatsby-link'

const Navigation = () => (
    <nav style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '1.45rem 1.0875rem',
      }}>
        <Link className="navigation__link" to="/">Home</Link>
        {/* <Link className="navigation__link" to="/page-2/">Page 2</Link> */}
        <Link className="navigation__link" to="/actualday/">Nächste Spiele</Link>
        <Link className="navigation__link" to="/actualgame/">Aktuelles Spiel</Link>
        <Link className="navigation__link" to="/groups/">Gruppen</Link>
        <Link className="navigation__link" to="/finals/">K.O.-Runde</Link>
    </nav>
)

export default Navigation


// WEBPACK FOOTER //
// ./src/components/navigation.js